import React, { useState, useRef, createRef, useEffect } from 'react';
import { MapContainer, TileLayer, useMapEvent, Marker, Popup, useMap } from 'react-leaflet';
import { faFileAlt, faSearch, faStreetView } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import moment from 'moment/moment';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
import FiltroPrefeitura from 'views/Shared/FiltroPrefeitura';
import FichaGeradorContainer from 'views/Cadastros/Geradores/components/FichaGeradorContainer';

//Assets
import { iconeNormal, iconeVermelho, iconeAmarelo, iconeNormalAtivo, iconeAmareloAtivo, iconeVermelhoAtivo } from '../../assets/Icons/Icons';

//Api
import mapasService_api from '../../api/mapasService_api';
import transportador_api from '../../api/transportador_api';
import modalidadeColeta_api from '../../api/modalidadeColeta_api';
import ramoDeAtividade_api from '../../api/ramoDeAtividade_api';
import gerador_api from '../../api/gerador_api';

//Helpers
import { getSessionCookie } from '../../helpers/cookies';
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';

//Context
import { useAuth } from '../../context/auth';
import { MAPA_TILE_URL, MAPA_TILE_ATTRIBUTION } from '../../helpers/mapas';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataInicial = new Date();
    const dataFinal = new Date();
    dataInicial.setDate(dataFinal.getDate() - 1);
    return {
        transportadorId: 0,
        transportadorId_selected: null,
        modalidadesIds: [],
        modalidadesIds_selected: [],
        ramoAtividadeIds: [],
        ramoAtividadeIds_selected: [],
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
        prefeituraId: 0,
        cnpj: null,
        endereco: ""
    };
}
export default function ColetasEfetuadas() {
    const { setupVariavel } = useAuth();

    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);

    //Dados do usuario logado
    const logado = getSessionCookie();

    const handlePrefeitura = (value) => {
        //salva o id da prefeitura nos filtros
        setFiltros({
            ...filtros,
            prefeituraId: value
        })

        setPrefeitura_Id(value);
        //Pegando os pontos de coletas efetuadas
        carregarColetas(value);
    }
    //Estado de controle dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado que guarda a referencia do mapa
    const [map, setMap] = useState(null);

    //Estado do ponto selecionado na lista
    const [pointSelected, setPointSelected] = useState(null);

    //Estado que controla a visualização dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Estado de controle da visualização de sateleti no mapa
    const [viewSatelite, setViewSatelite] = useState(() => false);

    //Troca o estado da visualização de sateleti
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);

    //Troca de estado de visualização dos filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    //Status possiveis para as coletas efetuadas
    const status = [
        { value: "Coleta efetuada sem previsão", color: "Warning", valueStatus: "SemPrevisao" },
        { value: "Previsão coletada com sucesso", color: "Success", valueStatus: "Finalizada" },
        { value: "Previsão não coletada", color: "Danger", valueStatus: "Programada" },
    ];
    //Estado que guarda as coletas efetuadas
    const [coletasEfetuadas, setColetasEfetuadas] = useState([]);

    //Estado que guarda as opções de transportadores para os filtros
    const [transportadores, setTransportadores] = useState([]);

    //Estado que guarda as opções das modalidades de coleta
    const [modalidadesDeColeta, setModalidadesDeColeta] = useState([]);

    //Estado que guarda as opções de ramos de atividades
    const [ramosDeAtividade, setRamosDeAtividade] = useState([]);

    //Estado de controle dos dados do gerador
    const [gerador, setGerador] = useState(null);

    //Estado que guarda a localização inicial do mapa
    const [location, setLocation] = useState([-23.2198396, -45.8915658]);
    //onChange para os campos de multi select
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        })
    }
    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        const ids = e.map(op => op.value);
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: ids
        })
    }
    //onChange para os campos de data
    const onChangeData = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Carrega as coletas efetuadas
    const carregarColetas = (prefeituraId = null) => {
        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        if (prefeituraId) {
            _filtros.prefeituraId = prefeituraId;
        }
        mapasService_api.ColetasEfetuadas(_filtros).then(response => {
            response.data = response.data.map(value => {

                value.divRef = createRef(null);
                value.markerRef = createRef(null);
                if (value.status == "Finalizada" || value.status == "Coleta Parcial" || value.status == "Coleta Total") {
                    value.statusDiv = "Finalizada";
                } else if (value.status == "Descarregando") {
                    value.statusDiv = "SemPrevisao";
                } else {
                    value.statusDiv = "Programada";
                }
                return value;

            });
            setColetasEfetuadas(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null)
        })
            .finally(f => setLoading(false));
    }

    const loadRamoDeAtividade = () => {
        setLoading(true);
        ramoDeAtividade_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            })
            setRamosDeAtividade(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false))
    }

    const loadTransportadores = () => {
        setLoading(true);
        transportador_api.GetAll().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, text: value.fantasia }
            });
            setTransportadores(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadModalidades = () => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setModalidadesDeColeta(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Estado que carrega as opções dos selects
    useEffect(() => {
        if(setupVariavel?.coordenadaPrefeitura){
            const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
            setLocation([parseFloat(latitude), parseFloat(longitude)])
        }

        loadRamoDeAtividade();
        loadModalidades();
        loadTransportadores();
    }, []);

    function handleFichaGerador(gerador) {
        setLoading(true);
        gerador_api.GetItem(gerador?.gerador_Id ? gerador?.gerador_Id : 0)
            .then(response => {
                if (response.data.tbPrefeituras_id) {
                    response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
                }
                if (response.data.tbSetores_Id) {
                    response.data.tbSetores_Id = response.data.tbSetores_Id.toString();
                }
                if (response.data.tbSegmentos_Id) {
                    response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
                }
                if (response.data.dataValidade) {
                    response.data.dataValidade = moment(response.data.dataValidade).format("YYYY-MM-DD")
                }

                response.data.localidades = response.data.localidades.map(localidade => {
                    if (localidade.localidadePadrao) {
                        localidade.principal = "Sim";
                    } else {
                        localidade.principal = "Não";
                    }
                    localidade.contratos = localidade.contratos.map(contrato => {
                        Object.keys(contrato).map(key => {
                            if (!contrato[key] === null) {
                                contrato[key] = "";
                            }

                        });
                        contrato.quantidadeContratada = contrato.quantidadeContratada ? contrato.quantidadeContratada.toString().replace(".", ",") : "";
                        return contrato;
                    });

                    return localidade;
                })
                setGerador(response.data);

            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (gerador) {
        return <MainCard
            btnVoltar={() => setGerador(null)}
        >
            <FichaGeradorContainer
                gerador={gerador}
                modulo={usuario.acesso.modulo}
                integracaoCadastros={false}
                visualizarFicha={true}
            />
        </MainCard>
    }

    return (
        <MainCard noCard title={"Coletas Efetuadas"} btnFiltros={toggleFiltros}>
            {loading && <Loading />}
            <div className={`filtros ${openFiltros ? "" : "close"}`} id={"filtros"}>
                <Row>
                    {logado.acesso.sigla === "GS" &&
                        <Col md={"12"} lg="4">
                            <TextField label="Transportadores"
                                value={filtros.transportadorId_selected}
                                name={"transportadorId_selected"}
                                type={"select"}
                                options={transportadores}
                                onChange={onChangeSelected}
                            />
                        </Col>
                    }
                    <Col md={"12"} lg="4">
                        <TextField
                            label="Modalidade de coleta"
                            value={filtros.modalidadesIds_selected}
                            name={"modalidadesIds_selected"}
                            type={"select"}
                            options={modalidadesDeColeta}
                            onChange={onChangeMultiSelect}
                            multiple
                        />
                    </Col>
                    <Col md={"12"} lg="4">
                        <TextField
                            label="Ramo de atividade"
                            value={filtros.ramoAtividadeIds_selected}
                            name={"ramoAtividadeIds_selected"}
                            type={"select"}
                            options={ramosDeAtividade}
                            onChange={onChangeMultiSelect}
                            multiple
                        />
                    </Col>
                    <Col md="12" lg="4" className='mx-0'>
                        <TextField
                            label={"Gerador (CNPJ)"}
                            name={"cnpj"}
                            type={"text"}
                            onChange={(e) => setFiltros({ ...filtros, [e.target.name]: e.target.value })}
                            value={filtros.cnpj}
                            mask={mascaras.cnpjMask}
                            maxLength={18}
                            onBlur={() => setFiltros({
                                ...filtros,
                                ["cnpj"]: mascaras.cnpjMask(filtros.cnpj, true)
                            })}
                        />
                    </Col>
                    <Col md="12" lg="4" className='mx-0'>
                        <TextField
                            label={"Logradouro e Número (separados por vírgula)"}
                            name="endereco"
                            value={filtros.endereco}
                            onChange={(e) => setFiltros({ ...filtros, [e.target.name]: e.target.value })}
                        />
                    </Col>
                    <Col md={"12"} lg="2">
                        <TextField
                            label="Data inicial"
                            type={"date"}
                            value={filtros.dataInicial}
                            name={'dataInicial'}
                            onChange={onChangeData}
                        />
                    </Col>
                    <Col md={"12"} lg="2">
                        <TextField
                            label="Data final"
                            type={"date"}
                            value={filtros.dataFinal}
                            name={"dataFinal"}
                            onChange={onChangeData}
                        />
                    </Col>
                    <Col md={"12"} lg="2" className='h-100'>
                        <Button color='info' style={{ color: "#fff" }} className={"mt-1 w-100"} onClick={(e) => carregarColetas()}> <FontAwesomeIcon icon={faSearch} className={"me-2"} /> Pesquisar</Button>
                    </Col>
                </Row>
            </div>
            <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
            {loading ?
                <></>
                :
                <Row style={{ height: "65vh", backgroundColor: "#eee" }} className="mt-3 rounded-3 overflow-hidden shadow" >
                    <Col md="12" lg="6" className=' m-0 p-0 overflow-auto ListagemDePontos d-none d-lg-block' style={{ height: "65vh" }}>
                        {
                            coletasEfetuadas.map((value, key) => {
                                return (
                                    <div key={key} ref={value.divRef} className={`rounded-3 p-2  m-2 shadow containerInfoMap ${pointSelected && pointSelected.id === value.id ? "active" : ""}`} onClick={() => {
                                        setLocation([parseFloat(value.latitude), parseFloat(value.longitude)]);
                                        if (map) {
                                            map.flyTo([parseFloat(value.latitude), parseFloat(value.longitude)]);
                                        }
                                        const marker = value.markerRef.current
                                        if (marker) {
                                            marker.openPopup()
                                        }
                                        setPointSelected(value);
                                    }}>
                                        {
                                            status.map((valueStatus, key) => {
                                                if (valueStatus.valueStatus === value.statusDiv) {
                                                    return (<p key={key} className={`status p-2 status${valueStatus.color} rounded-3`}> <span className="fw-bold" >Status: </span> {valueStatus.value}</p>)
                                                }
                                            })
                                        }
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className='m-1'> <span className="fw-bold">Identificacao: </span> {value.fantasia}</p>
                                            <p className='m-1'> <span className="fw-bold">Data da coleta: </span> {moment(value.dataColeta).format("DD/MM/YYYY")}</p>
                                        </div>
                                        <p className='m-1'> <span className="fw-bold">Endereco: </span> {value.endereco}</p>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className='m-1'> <span className="fw-bold">Transportador: </span> {value.transportador}</p>
                                            <p className='m-1'> <span className="fw-bold">Destino: </span> {value.destino}</p>
                                        </div>
                                        <div className="mt-3 d-flex align-items-center justify-content-center w-100">
                                            <Button style={{ fontSize: "8pt" }} color='primary' onClick={() => handleFichaGerador(value)}>
                                                <FontAwesomeIcon size='1x' icon={faFileAlt} className='mr-2' /> Visualizar Ficha do Gerador
                                            </Button>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </Col>
                    <Col md="12" lg="6" className=' m-0 p-0'>
                        <MapContainer
                            center={location}
                            zoom={13}
                            ref={map}
                            whenCreated={mapRef => setMap(mapRef)}
                            style={{ height: "100%", width: "100%", backgroundColor: "#333" }}
                        >
                            <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>
                            <TileLayer
                                url={MAPA_TILE_URL}
                                attribution={MAPA_TILE_ATTRIBUTION}
                            />
                            {
                                viewSatelite
                                &&
                                <TileLayer
                                    url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                                    maxZoom={20}
                                    subdomains={['mt1', 'mt2', 'mt3']}
                                />

                            }

                            <MarkerClusterGroup>
                                {coletasEfetuadas.map((value, index) => {
                                    let icone;
                                    if (value.statusDiv == "Finalizada") {
                                        icone = iconeNormal;
                                    } else if (value.statusDiv == "Programada") {
                                        icone = iconeVermelho;
                                    } else {
                                        icone = iconeAmarelo;
                                    }
                                    return (

                                        <Marker key={index} icon={icone} position={[parseFloat(value.latitude), parseFloat(value.longitude)]}
                                            eventHandlers={{
                                                click: (e) => {
                                                    setLocation(e.latlng);
                                                    if (map != null) {
                                                        map.flyTo(e.latlng);
                                                    }
                                                    value.divRef.current.scrollIntoView({ behavior: 'smooth', block: "center" });
                                                    setPointSelected(value);
                                                },
                                            }}
                                            ref={value.markerRef}
                                        >
                                        </Marker>
                                    )
                                })}
                            </MarkerClusterGroup>
                        </MapContainer>
                    </Col>
                </Row>
            }
            {
                pointSelected &&
                <Row className='d-lg-none'>
                    <Col md={"12"} className={"m-0"}>
                        <div className='rounded-3 p-2 mt-4 shadow' style={{ backgroundColor: "#ffffff", color: "#666" }}>
                            <div className='d-flex align-items-center justify-content-end'><p className='d-inline p-2 fw-bold' onClick={() => setPointSelected(null)}>X</p></div>
                            {
                                status.map((valueStatus, key) => {
                                    if (valueStatus.valueStatus === pointSelected.statusDiv) {
                                        return (<p key={key} className={`status p-2 status${valueStatus.color} rounded-3`}> <span className="fw-bold" >Status: </span> {valueStatus.value}</p>)
                                    }
                                })
                            }

                            <p className='m-1'> <span className="fw-bold">Identificacao: </span> {pointSelected.fantasia}</p>
                            <p className='m-1'> <span className="fw-bold">Endereco: </span> {pointSelected.endereco}</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className='m-1'> <span className="fw-bold">Transportador: </span> {pointSelected.transportador}</p>
                                <p className='m-1'> <span className="fw-bold">Destino: </span> {pointSelected.destino}</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            }
        </MainCard>
    )
}